import React, { useEffect, useState } from "react";
import { setTitle } from "../helpers/MetaTag";
import PageBanner from "../components/section/PageBanner";
import AboutServices from "../components/section/Aboutus/AboutServices";
import HomeAboutUs from "../components/section/Home/HomeAboutUs";
import { postData } from "../services/api";
import AboutService from "../components/section/Aboutus/AboutService";
import { useTranslation } from "react-i18next";
import TeamSection from "../components/section/Aboutus/TeamSection";

const AboutUsPage = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | About Us"
  );
  const { i18n, t } = useTranslation();
  const [pageData, setPageData] = useState({});
  const [intro3, setIntro3] = useState({});
  const [intro2, setIntro2] = useState({});

  useEffect(() => {
    const loadPageDetails = async () => {
      try {
        const result = await postData("/lead-content/details", {
          slug: "intro2",
        });
        if (result.data) {
          setPageData(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPageDetails();

    const loadPageDetails3 = async () => {
      try {
        const result = await postData("/lead-content/details", {
          slug: "intro3",
        });
        if (result.data) {
          setIntro3(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPageDetails3();

    const loadPageDetails2 = async () => {
      try {
        const result = await postData("/lead-content/details", {
          slug: "request-demo",
        });
        if (result.data) {
          setIntro2(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPageDetails2();
  }, []);

  return (
    <>
      <PageBanner title={t("about_us")} />
      <HomeAboutUs />
      <AboutService headingOne={true} headingTwo={true} headingThree={true} />
      <TeamSection />
    </>
  );
};

export default AboutUsPage;
